export const auth = {
  login: '/members/login',
  loginKakao: '/members/login/kakao',
};

export const posts = {
  list: '/posts',
  submit: '/posts',
  comment: (postId) => `/posts/${postId}/comments`,
  yearMonth: '/posts/year-months',
  delete: (postId) => `/posts/${postId}`,
  deleteComment: (postCommentId) => `/posts/comments/${postCommentId}`,
};

export const map = {
  modify: (layerName, featureId) => `/layers/${layerName}/${featureId}/geometry`,
};

export const sites = {
  list: '/sites',
  add: '/sites',
  detail: (siteId) => `/sites/${siteId}`,
  memo: (siteId) => `/sites/${siteId}/memo`,
};

export const layers = {
  list: '/layers',
  add: '/layers',
  detail: (layerId) => `/layers/${layerId}`,
  delete: (layerId) => `/layers/${layerId}`,
  publish: (layerId) => `/layers/${layerId}/publish`,
  east: (layerId) => `/layers/${layerId}`,
  center: (layerId) => `/layers/${layerId}`,
};
